<template>
  <div>
    <Header class="header" :height="40" title="个股两融买卖明细"/>
    <div class="list-container">
      <div class="head">
        <div class="xv-symbol">
          <div style="line-height: .3rem">序</div>
          <div class="symbol-code">证券/代码</div>
        </div>
        <div ref="headnoscroll" class="headnoscroll" @touchstart="connectBodyScroll($event)">
          <div class="spj align-left">收盘价/涨幅</div>
          <div class="buy align-left">融资买入额</div>
          <div class="rzche align-left">融资偿还额</div>
          <div class="rzjme align-left">融资净买额</div>
          <div class="rzye align-left">融资余额</div>
          <div class="rzyezlb align-left">融资余额占流比</div>
          <div class="rzmcl align-left">融券卖出量</div>
          <div class="rzchl align-left">融券偿还量</div>
          <div class="rzjml align-left">融券净卖量</div>
          <div class="rqyl align-left">融券余量</div>
          <div class="rqye align-left">融券余额</div>
          <div class="lrye align-left">两融余额</div>
          <div class="lryecz align-left">两融余额差值</div>
        </div>
      </div>
      <div class="list">
        <div class="headList">
          <div class="headItem" v-for="(v, k) in symbolName" :key="k" @click="$router.push({path:`/rzrq/${v.SecuAbbr}-${v.SecuCode}/${v.InnerCode}.html`})">
            <div class="xv-symbol symbol-item">
              <div class="index">{{ k+1 }}</div>
              <div class="symbol-code">
                <div class="market">
                  <img v-if="v.SecuMarket === '83'" src="@/assets/sh.png">
                  <img v-else-if="v.SecuMarket === '90'" src="@/assets/sz.png">
                </div>
                <div class="code-name">
                  <div class="name">{{ v.SecuAbbr }}</div>
                  <div class="code">{{ v.SecuCode }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
        <div ref="datalist" class="dataList" @scroll="connectHeadScroll">
          <div class="dataItem" v-for="(v, k) in list" :key="k" @click="$router.push({path:`/rzrq/${v.SecuAbbr}-${v.SecuCode}/${v.InnerCode}.html`})">
            <div class="spj align-left">
            <div :class="{'red': v.UpDownRatio > 0, 'green': v.UpDownRatio < 0, 'black': v.UpDownRatio == 0}">
              <div class="j">{{ v.ClosePrice.toFixed(2) }}</div>
              <div class="zf">{{ (v.UpDownRatio*100).toFixed(2) + '%' }}</div>
            </div>
            </div>
            <div class="buy align-left money">
              {{ formatUnit(v.FinanceBuyValue) }}
            </div>
            <div class="rzche align-left money">{{ formatUnit(v.FinanceRefundValue) }}</div>
            <div class="rzjme align-left money" :class="{'red':v.FinancePureValue > 0, 'green': v.FinancePureValue < 0}">{{ formatUnit(v.FinancePureValue) }}</div>
            <div class="rzye align-left money">{{ formatUnit(v.FinanceValue) }}</div>
            <div class="rzyezlb align-left money">{{ (v.FinaInTotalRatio*100).toFixed(2) + '%' }}</div>
            <div class="rzmcl align-left money">{{ formatUnit(v.SecuritySellVolume) }}</div>
            <div class="rzchl align-left money">{{ formatUnit(v.SecurityRefundVolume) }}</div>
            <div class="rzjml align-left money" :class="{'red':v.SecurityPureValue > 0, 'green': v.SecurityPureValue < 0}">{{ formatUnit(v.SecurityPureValue) }}</div>
            <div class="rqyl align-left money">{{ formatUnit(v.SecurityVolume) }}</div>
            <div class="rqye align-left money">{{ formatUnit(v.SecurityValue) }}</div>
            <div class="lrye align-left money">{{ formatUnit(v.FinanceSecurityValue) }}</div>
            <div class="lryecz align-left money">{{ formatUnit(v.FinanceSecurityDiffValue) }}</div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import rzrq from '@/api/rzrq'
import {request} from '@/api/request'
import Header from '@/components/header.vue'
import Utils from '@/utils/formatUnit'

export default {
  components: {
    Header
  },
  data() {
    return {
      market: this.$route.query.market,
      date: this.$route.query.date,
      symbolName: [],
      list: [],
      symbolLeft: 0,
      headLeft: 0,
      scolling: false,
      timer: null
    }
  },
  async mounted() {
    this.list = await this.getRzrqDetail()
    this.symbolName = this.list.map(v => {
      return {SecuAbbr: v.SecuAbbr, SecuCode: v.SecuCode, SecuMarket: v.SecuMarket}
    })
  },
  methods: {
    formatUnit(val) {
      if(!val) return '--'
      return Utils.formatUnit(val)
    },
    async getRzrqDetail() {
      const res = await request.get({
          url: rzrq.queryFinaSecuIndidualDetailRongquanTable,
          params: {market: this.market, date: this.date,pageSize: 100}
      })
      return res
    },
    connectHeadScroll() {
      this.$refs.headnoscroll.scrollLeft = this.$refs.datalist.scrollLeft
    },
    connectBodyScroll(event) {
      event.preventDefault()
    }

  },
}
</script>
<style lang="stylus" scoped>
.list-container
  padding 0 0 0 0.12rem
  margin-top 40px
  background #ffffff
  height calc(100vh - .4rem)
  overflow hidden
.header
  font-weight 500
  /deep/ p 
    font-size .17rem
.head
  height .3rem
  display flex
  font-family PingFangSC-Regular,PingFang SC
  color #999999
  line-height .18rem
  white-space nowrap
.headList
  overflow visible
  flex-shrink 0
.dataList
  width calc(100vw - 1.4rem)
  overflow-x auto
  overflow-y visible
  -webkit-overflow-scrolling touch
  &::-webkit-scrollbar
    display none
.list
  display flex
  height calc(100% - .3rem)
  overflow-y auto
  overflow-x hidden
  -webkit-overflow-scrolling touch
  &::-webkit-scrollbar
    display none
.xv-symbol
  width 1.4rem
  text-align left
  flex-shrink 0
  display flex
  position relative
  &:after
    content: ''
    width 0.32rem
    height 100%
    position absolute
    right -.17rem
    top 0
    background linear-gradient(270deg,rgba(238,238,238,0) 0%,rgba(216,216,216,0.5) 100%)
  .symbol-code
    margin-left .17rem
    display flex
    justify-content flex-start
    align-items center
  .market
    width .15rem
    height 100%
    padding-top .13rem
    margin-right .02rem
    box-sizing border-box
    img
      display block
  .name
    line-height .24rem
    font-weight 500
    font-size .17rem
    font-family PingFangSC-Medium,PingFang SC
    color #333333
    white-space nowrap
  .code
    line-height .15rem
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    color #999999
.spj
  width .72rem
  .j
    font-size .17rem
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    line-height .2rem
    margin-bottom .02rem
    text-align right
  .zf
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    line-height .15rem
    text-align right
.buy
  width .9rem
.rzche
  width .9rem
.rzjme
  width .95rem
.rzye
  width .84rem
.rzyezlb
  width 1.21rem
.rzmcl
  width .95rem
.rzchl
  width .95rem
.rzjml
  width .95rem
.rqyl
  width .95rem
.rqye
  width .84rem
.lrye
  width .84rem
.lryecz
  width 1.2rem
  padding-right .24rem
  box-sizing border-box
.align-left
  display flex
  flex-shrink 0
  justify-content flex-end
  align-items center
.headItem
  .index
    width .13rem
    text-align center
    font-size .15rem
    color #333333
    line-height .21rem
    font-family PingFangSC-Regular,PingFang SC
    margin-top .06rem
  .symbol-item
    background #ffffff
    height .5rem
    will-change transform
.dataItem
  display flex
  height .5rem
  .money
    font-size .17rem
    font-family DINAlternate-Bold,DINAlternate
    font-weight bold
    color #333333
  .red
    color #F43737
  .green
    color #1BAA3C
  .black
    color #333333
.headnoscroll
  display flex
  width calc(100vw - 1.5rem)
  overflow-x auto
  -webkit-overflow-scrolling touch
  &::-webkit-scrollbar
    display none
</style>